import { render } from "./Userpolicestation.vue?vue&type=template&id=3b85d11c"
import script from "./Userpolicestation.vue?vue&type=script&lang=js"
export * from "./Userpolicestation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__